export default __webpack_public_path__ + "static/weather-journal3-c963a252ce897697549004e2f140c044.png";